/* Fitvids */
fitvids()
